import { render, staticRenderFns } from "./RevitElementSubelementsTab.vue?vue&type=template&id=da3482f0&scoped=true"
import script from "./RevitElementSubelementsTab.vue?vue&type=script&lang=ts"
export * from "./RevitElementSubelementsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da3482f0",
  null
  
)

export default component.exports